import "./App.css";
import PermissionRoutes from "./components/RoleManagement/PermissonRoutes";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { useEffect, useState } from "react";


function App() {

  const [permissions, setPermissions] = useState([])
  const refreshPermission = (perm) => {
    const permissionsString = perm ? perm : localStorage.getItem('permissions');
    try {
      if (permissionsString) {
        setPermissions(JSON.parse(permissionsString));
      }
    } catch (error) {
      console.error('Error parsing permissions:', error);
    }
  }

  useEffect(() => {
    refreshPermission(null)
  }, [])

  return (
    <>
      <PermissionRoutes permissions={permissions} refreshPermission={refreshPermission} />
      {/* <Routes> */}
      { /* <Route element={<AuthRoute />}>
          <Route element={<DefaultContainer />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/importreport" element={<ImportReport />} />
            <Route path="/exportreport" element={<ExportReport />} />
            <Route path="/cdp" element={<CDP />} />
            <Route path="/gri" element={<GRI />} />
            <Route path="/tsp" element={<TSP />} />
            <Route path="/esgreport" element={<EsgReport />} />
            <Route path="/sasbreport" element={<SasbReport />} />
            <Route path="/teammanagement" element={<TeamManagement />} />
            <Route path="/goal" element={<Authorization path="/goal"> <Goal /> </Authorization>} />
            <Route path="/creategoal" element={<Authorization path="/creategoal"><CreateGoal /> </Authorization>} />
            <Route path="/goaldetailpage" element={<GoalsDetailPage />} />
            <Route path="/assigngoal" element={<AssignGoal />} />
            <Route path="/internal-reports" element={<InternalReports />} />
            <Route path="/supplier-reports" element={<SupplierReports />} />
            <Route path="/internal-dashboards" element={<InternalDashboards />} />
            <Route path="/supplier-dashboards" element={<SupplierDashboards />} />
            <Route path="/supplier-data-graph" element={<SupplierDataGraph />} />
            <Route path="/esg-dashboards" element={<EsgDashboards />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/editprofile" element={<Editprofile />} />
            <Route path="/tspsupplierreport" element={<TspSupplierReport />} />
            <Route path="/tspsupplierreportdetails" element={<TspSupplierReportDetails />} />
            <Route path="/grisupplierreport" element={<GriSupplierReport />} />
            <Route path="/grisupplierreportdetails" element={<GriSupplierReportDetails />} />
            <Route path="/assets" element={<Facilities />} />
            <Route path="/assetdetails" element={<FacilityDetails />} />
            <Route path="/assetanalyticdetail" element={<FacilityAnalyticDetail />} />
            <Route path="/airquality" element={<AirQuality />} />
            <Route path="/watermanagement" element={<WaterManagement />} />
            <Route path="/hazardousmanagement" element={<HazardousManagement />} />
            <Route path="/energymanagement" element={<EnergyManagement />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reportform" element={<NewReportForm />} />
            <Route path="/reportsdatadetails" element={<ReportsDataDetails />} />
            <Route path="/reportswaterdatadetails" element={<ReportsWaterDataDetails />} />
            <Route path="/tspsupplierreportfinal" element={<TspSupplierReportFinal />} />
            <Route path="/tspsupplierreportfinaldata" element={<TspSupplierReportFinalData />} />
            <Route path="/cdpqna" element={<CDPQNA />} />
            <Route path="/griqna" element={<Griqna />} />
            <Route path="/griqnadetails" element={<GriqnaDetails />} />
            <Route path="/sasbform" element={<SasbForm />} />
            <Route path="/sasb" element={<Sasb />} />
            <Route path="/create-user" element={<CreateUser />} />
            <Route path="/create-role" element={<CreateRole />} />
            <Route path="/assign-permission" element={<AssignPermission />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        {/* </Route> */}
      {/* <Route path="/" element={<Login />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
      </Routes> */}
    </>
  );
}

export default App;
